import { Button } from "@clockwise/design-system";
import { Close } from "@clockwise/design-system/icons";
import useIsNarrow from "@clockwise/web-commons/src/hooks/useIsNarrow";
import {
  useReadActiveEvent,
  useUpdateActiveEvent,
} from "@clockwise/web-commons/src/util/ActiveEventContext";
import { useUpdateCalendarColors } from "@clockwise/web-commons/src/util/CalendarColorsContext";
import { Dialog } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { EventRenderer } from "../../event/EventRenderer";
import { usePlannerContext } from "../Context";
import { useSetAdditionalCalendarIds } from "../context/hooks/useAdditionalCalendarIds";

export const DismissButton = ({ onClose }: { onClose?: () => void }) => {
  const handleClose = () => {
    onClose?.();
  };
  return (
    <div className="cw-flex cw-items-end cw-flex-col cw-pr-2 cw-pt-1">
      <Button onClick={handleClose} variant="text" startIcon={Close} />
    </div>
  );
};

export const SidebarContainer = ({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose?: () => void;
}) => {
  const { calendarRef } = usePlannerContext();
  const isNarrow = useIsNarrow(calendarRef, 500);

  if (isNarrow) {
    return (
      <Dialog open fullScreen>
        <div className="cw-w-full cw-h-screen cw-flex cw-flex-col cw-pb-2 cw-z-30 cw-shrink-0 cw-overflow-auto">
          <DismissButton onClose={onClose} />
          {children}
        </div>
      </Dialog>
    );
  }

  return (
    <div
      className={classNames(
        "cw-w-[300px] cw-h-screen cw-flex cw-flex-col cw-pb-2",
        "cw-z-30 cw-shrink-0 cw-overflow-auto cw-border-l cw-border-neutral cw-border-solid cw-shadow-left",
      )}
    >
      <DismissButton onClose={onClose} />
      {children}
    </div>
  );
};

export const PlannerSidebar = () => {
  const activeEvent = useReadActiveEvent();
  const updateActiveEvent = useUpdateActiveEvent();
  const setAdditionalCalendarIds = useSetAdditionalCalendarIds();
  const dispatchCalendarColors = useUpdateCalendarColors();

  const handleClose = () => {
    setAdditionalCalendarIds?.([]);
    dispatchCalendarColors({ type: "reset" });
    updateActiveEvent(null);
  };

  if (activeEvent?.externalEventId) {
    return (
      <SidebarContainer onClose={handleClose}>
        <div className="cw-pr-1 cw-h-full cw-w-full">
          <EventRenderer event={activeEvent} />
        </div>
      </SidebarContainer>
    );
  }

  return null;
};
